import i18n from "i18n";

export const currentUserMessages = {
  profileUpdate: i18n.t('notifications.currentUser.profileUpdate')
};
